import WorkerShares from './WorkerShares';

export default WorkerShares;
